module.exports = __webpack_public_path__ + "static/media/message-chat-box.b2f31ad4.png";